import { ResponseCanal } from "../canais/canais.service";
import { IdCanal, IdUsuario } from "../common-types";
import { GenericServiceBase } from "../generic-service";
import { ResponseUsuario } from "../usuarios/usuarios.service";

export type ResponseUsuarioCanal = ResponseUsuario & { visualizacaoGlobal: boolean };

/** Usuário elegível a atendente de um canal (enxerga o inbox dono do canal). */
export type ResponseCandidatoCanal = ResponseUsuario;

export class UsuariosCanaisService extends GenericServiceBase {
    constructor() {
        super('usuarios-canais')
    }

    async vincularUsuariosToCanal(idCanalArray: IdCanal[], idUsuarioArray: IdUsuario[]): Promise<void> {
        return await this.f.post(`/canais/usuarios`, { idsCanais: idCanalArray, idsUsuarios: idUsuarioArray}) as void;
    }

    async getUsuariosByCanal(idCanal: IdCanal): Promise<ResponseUsuarioCanal[]> {
        return await this.f.get(`/canais/${idCanal}/usuarios`) as ResponseUsuarioCanal[];
    }

    /**
     * Candidatos a atendente do canal: usuários da conta que realmente enxergam o
     * inbox dono do canal (ou têm acesso global). Mesma regra que o backend aplica
     * ao gravar o vínculo — evita oferecer usuário que seria descartado.
     */
    async getCandidatosByCanal(idCanal: IdCanal): Promise<ResponseCandidatoCanal[]> {
        return await this.f.get(`/canais/${idCanal}/candidatos`) as ResponseCandidatoCanal[];
    }

    async getCanaisByUsuario(idUsuario: IdUsuario): Promise<ResponseCanal[]> {
        return await this.f.get(`/usuarios/${idUsuario}/canais`) as ResponseCanal[];
    }

    async deleteUsuariosFromCanal(idCanal: IdCanal, idUsuarioArray: IdUsuario[]): Promise<void> {
        return await this.f.delete(`/canais/${idCanal}/usuarios`, {idsUsuarios: idUsuarioArray}) as void;
    }

    async atualizarVisualizacaoGlobal(idCanal: IdCanal, idUsuario: IdUsuario, visualizacaoGlobal: boolean): Promise<void> {
        return await this.f.patch(`/vinculos/visualizacao-global`, { idCanal, idUsuario, visualizacaoGlobal }) as void;
    }

    async getMeusCanaisVisualizacaoGlobal(): Promise<IdCanal[]> {
        return await this.f.get(`/me/visualizacao-global`) as IdCanal[];
    }

    /**
     * Grava a ordem dos canais deste usuário no Kanban.
     *
     * Manda a lista visível inteira, na ordem final — o servidor reescreve os vínculos
     * desses canais a partir do índice de cada um. Espelha `QuadroKanbanService.reordenar`.
     */
    async reordenar(canais: IdCanal[]): Promise<{ idCanal: IdCanal; ordem: number }[]> {
        return await this.f.put(`/me/canais/ordem`, { canais }) as { idCanal: IdCanal; ordem: number }[];
    }
}
